import React from "react"

export const CourseProductWarning = () => {
  return(
    <div className='alert product_warning stick_to_breadcrumb'>
      <ul className='list-inline'>
        <li className='warning-note'>
          {window.I18n.t('courses.note')}:
        </li>
        <li className='warning-text-container'>
          {window.I18n.t('courses.product_warning')}
        </li>
      </ul>
    </div>
  )
}